module.exports = __webpack_public_path__ + "img/title_cn@2x.1e5d4d3a.png";